import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const listSkillAgentRapports = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-rapports`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentRapportById = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-rapports/${id}`,
    {
      headers: authHeaders(),
    },
  );
  return response.data;
};

export const createSkillAgentRapport = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-rapports`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

/** Rapport en rama Rapports desde fotos de reunión (primera imagen = trozo). */
export const createSkillAgentRapportFromMeeting = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-rapports/from-meeting`,
    payload,
    { headers: authHeaders(), timeout: 180000 },
  );
  return response.data;
};

export const updateSkillAgentRapport = async (id, formData) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-rapports/${id}`,
    formData,
    { headers: authHeaders() },
  );
  return response.data;
};

export const generateSkillAgentRapportTile = async (
  id,
  cropBlob,
  {
    engine,
    widthCm,
    heightCm,
    threadsPerCm,
    weave,
    colors,
    sampleWidthCm,
  } = {},
) => {
  const body = new FormData();
  if (cropBlob) body.append("crop", cropBlob, "crop.jpg");
  const eng = engine === "seamless" || engine === "tartan" ? engine : "tartan";
  body.append("engine", eng);
  if (widthCm != null && widthCm !== "")
    body.append("widthCm", String(widthCm));
  if (heightCm != null && heightCm !== "")
    body.append("heightCm", String(heightCm));
  if (threadsPerCm != null && threadsPerCm !== "")
    body.append("threadsPerCm", String(threadsPerCm));
  if (weave) body.append("weave", String(weave));
  if (colors != null && colors !== "") body.append("colors", String(colors));
  if (sampleWidthCm != null && sampleWidthCm !== "")
    body.append("sampleWidthCm", String(sampleWidthCm));
  const response = await axios.post(
    `${API_URL}/api/skill-agent-rapports/${id}/generate-tile`,
    body,
    {
      headers: authHeaders(),
      timeout: 320000,
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    },
  );
  return response.data;
};

export const deleteSkillAgentRapport = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-rapports/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const fetchSkillAgentRapportBlob = async (id, kind) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-rapports/${id}/${kind}`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return response.data;
};
